import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AdsPromoBanner } from "@/components/ads/AdsPromoBanner";
import { AdsHeroV2 } from "@/components/ads/AdsHeroV2";
import { AdsOfferBanner } from "@/components/ads/AdsOfferBanner";
import { AdsFinancingSection } from "@/components/ads/AdsFinancingSection";
import { AdsComparisonTable } from "@/components/ads/AdsComparisonTable";
import { AdsFreeInspectionCTA } from "@/components/ads/AdsFreeInspectionCTA";
import { AdsServicesTabs } from "@/components/ads/AdsServicesTabs";
import { Testimonials } from "@/components/Testimonials";
import { AdsBottomCTA } from "@/components/ads/AdsBottomCTA";
import { AdsMinimalFooter } from "@/components/ads/AdsMinimalFooter";
import { SEOHead } from "@/components/SEOHead";
import { usePhoneNumber } from "@/hooks/usePhoneNumber";
import { usePhoneBar } from "@/contexts/PhoneBarContext";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

interface Service {
  id: string;
  slug: string;
  name: string;
  description: string;
  hero_title_template: string;
  hero_subtitle_template: string;
  service_list: string[];
  is_emergency: boolean;
  meta_title_template: string;
  meta_description_template: string;
}

const AdsRoofingLanding = () => {
  const serviceSlug = "roofing";
  const formattedCity = "Long Island";
  const { setPhoneNumber } = usePhoneBar();
  const [service, setService] = useState<Service | null>(null);
  const [loading, setLoading] = useState(true);
  const phoneInfo = usePhoneNumber(undefined);

  useEffect(() => {
    setPhoneNumber(phoneInfo.tel);
  }, [phoneInfo.tel, setPhoneNumber]);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const { data, error } = await supabase
          .from("services")
          .select("*")
          .eq("slug", serviceSlug)
          .single();

        if (error || !data) {
          setService(null);
        } else {
          setService(data);
        }
      } catch (err) {
        console.error("Error fetching service:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchService();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!service) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="theme-crimson">
      <SEOHead
        cityName={formattedCity}
        title={service.meta_title_template?.replace("{city}", formattedCity)}
        description={service.meta_description_template?.replace("{city}", formattedCity)}
        canonical="https://quote.safewayroofingandchimney.com/ads/roofing"
      />
      <AdsPromoBanner />
      <main className="min-h-screen">
        <AdsHeroV2 />
        <AdsOfferBanner />
        <AdsFinancingSection />
        <AdsComparisonTable />
        <AdsFreeInspectionCTA />
        <AdsServicesTabs />
        <Testimonials />
        <AdsBottomCTA />
      </main>
      <AdsMinimalFooter />
    </div>
  );
};

export default AdsRoofingLanding;
